export default __webpack_public_path__ + "static/media/pumapay-comment-bg.901b54e4.png";